<template>
	<div class="assignment">
    <base-banner
			:title="banner.title"
			:caption="banner.caption"
			:backgroundImage="banner.image"
			:titleColor="banner.titleColor"
			:captionColor="banner.captionColor"
			:backgroundColor="banner.backgroundColor"
      :buttons="banner.buttons"
		>
		</base-banner>

    <base-goto :breadcrumbs="breadcrumbs"></base-goto>

    <div id="content">
      <div id="assignment" class="sec">
        <v-row justify="center" align="center" class="header">
					<v-col cols="12">
            <div class="text-center">
              <div
                :class="MIXIN_SETUP_UI.header"
                class="mb-5 font-weight-bold primary--text"
                data-aos="fade-up"
              >
                Key Assignment
              </div>
              <div
                class="d-block primary--text"
                data-aos="fade-up"
              >
                <div :class="MIXIN_SETUP_UI.title" class="font-weight-bold">Congrats on your purchase!</div>
              </div>
              <div data-aos="fade-up" :class="MIXIN_SETUP_UI.defaultSidePadding">
                <p>Be advised that your key is only active until it's expiration period.</p>
              </div>
            </div>
          </v-col>
				</v-row>

        <v-row justify="center">
          <v-card
            rounded="xl"
            flat
            width="520px"
            min-height="720px"
            class="card"
            data-aos="fade-up"
            :class="[ MIXIN_SETUP_UI.show ? 'ma-10' : 'ma-5' ]"
          >
            <v-form ref="assignmentForm">
              <v-col cols="12">
                <!-- First Name -->
                <v-text-field
                  label="First Name*"
                  type="text"
                  ref="firstName"
                  v-model="firstName"
                  :rules="[() => !!firstName || 'This field is required']"
                  :error-messages="errorMessages"
                ></v-text-field>

                <!-- Middle Name -->
                <v-text-field
                  label="Middle Name"
                  type="text"
                  ref="middleName"
                  v-model="middleName"
                  :error-messages="errorMessages"
                ></v-text-field>
                  <!-- :rules="[() => !!middleName || 'This field is required']" -->

                <!-- Last Name -->
                <v-text-field
                  label="Last Name*"
                  type="text"
                  ref="lastName"
                  v-model="lastName"
                  :rules="[() => !!lastName || 'This field is required']"
                  :error-messages="errorMessages"
                ></v-text-field>

                <!-- Birthdate -->
                <v-menu
                  v-model="birthdateMenu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      placeholder="M/D/YYYY"
                      :rules="[() => !!birthdate || 'This field is required']"
                      v-model="birthdateFormat"
                      label="Birthdate*"
                      append-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="birthdate"
                    ref="birthdate"
                    :error-messages="errorMessages"
                    no-title
                    @input="birthdateMenu = false"
                    :max="maxDate"
                  ></v-date-picker>
                </v-menu>

                <!-- GENDER -->
                <v-radio-group
                  row
                  label="Gender"
                  v-model="gender"
                  :rules="MIXINS_REQUIRED_RULES"
                >
                  <v-radio
                    label="Male"
                    value="male"
                  ></v-radio>
                  <v-radio
                    label="Female"
                    value="female"
                  ></v-radio>
                </v-radio-group>
                
                <!-- Email Address -->
                <v-text-field
                  label="Email Address*"
                  type="text"
                  ref="emailAddress"
                  v-model="emailAddress"
                  :rules="[() => !!emailAddress || 'This field is required',
                           () => /.+@.+\..+/.test(emailAddress) || 'Email must be valid']"
                  :error-messages="errorMessages"
                ></v-text-field>

                <!-- Company -->
                <v-text-field
                  label="Company"
                  v-model="company"
                ></v-text-field>


                <!-- Contact Number -->
                <v-text-field
                  label="Contact Number*"
                  type="text"
                  ref="contactNumber"
                  v-model="contactNumber"
                  :rules="[
                    () => !!contactNumber || 'This field is required',
                    v => /^(?!.*  )(?=.*[\w-])[\w -]{1,11}$/.test(v) || 'Up to 11 characters allowed',
                    v => /^\d+$/.test(v) || 'Only numbers are allowed'
                  ]"
                  :error-messages="errorMessages"
                ></v-text-field>

                <!-- Provider Number -->
                <!-- <v-text-field
                  label="Provider Number*"
                  type="text"
                  v-model="providerNumber"
                  :rules="[() => !!providerNumber || 'This field is required']"
                  :error-messages="errorMessages"
                ></v-text-field> -->

                <!-- Employment Status -->
                <v-select
                  v-model="employmentStatus"
                  :items="employmentStatuses"
                  label="Employment Status"
                ></v-select>

                <!-- Access Key -->
                <v-text-field
                  label="Access Key*"
                  ref="accessKey"
                  v-model="accessKey"
                  :rules="[() => !!accessKey || 'This field is required']"
                  :error-messages="errorMessages"
                  :append-icon="showKey ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="showKey ? 'text' : 'password'"
                  @click:append="showKey = !showKey"
                ></v-text-field>

                <!-- Activation Code -->
                <v-text-field
                  label="Activation Code*"
                  ref="activationCode"
                  v-model="activationCode"
                  :rules="[() => !!activationCode || 'This field is required']"
                  :error-messages="errorMessages"
                  :append-icon="showCode ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="showCode ? 'text' : 'password'"
                  @click:append="showCode = !showCode"
                ></v-text-field>

                <!-- Submit button -->
                <div class="text-center mt-5">
                  <base-button
                    name="Send"
                    color="#0e6ccd"
                    x-large
                    min-width="50%"
                    @click="confirmAssignmentInfo()"
                    :loading="loading"
                  ></base-button>
                </div>
              </v-col>
            </v-form>
          </v-card>
        </v-row>

      </div>
    </div>

    <base-confirm-dialog
			v-model="confirmDialog"
			title="Confirm"
			message="Would you like to send a key assignment request?"
			@do="saveAssignmentInfo()"
      :loading="loading"
		></base-confirm-dialog>

		<base-success-dialog
			v-model="successDialog"
			title="Thank you!"
			message="You have successfully activated your account. You may now call us anytime for any health concerns."
		></base-success-dialog>

    <base-error-dialog
			v-model="errorDialog.show"
			:title="errorDialog.title"
			:message="errorDialog.message"
		></base-error-dialog>
  </div>
</template>

<script>
import Repository from "@/api/repositories";
const ShopAssignmentBannersApi = Repository.get("shopAssignmentBanners");
const KeyAssignmentApi = Repository.get("keyAssignments");

export default {
  name: "ShopAssignment",
  components: {
    //
  },
  data() {
    return {
      birthdateMenu: false,
      birthdateFormatted: this.formatDate(new Date().toISOString().substr(0, 10)),
      /* form fields */
      firstName: null,
      middleName: null,
      lastName: null,
      birthdate: null,
      emailAddress: null,
      contactNumber: null,
      accessKey: null,
      activationCode: null,
      gender: 'male',
      company: null,
      employmentStatus: null,
      // providerNumber: null,
      /** Test form inputs */
      // firstName: "test",
      // middleName: "test",
      // lastName: "test",
      // birthdate: "01-31-1999",
      // emailAddress: "test@test.com",
      // contactNumber: "0197977",
      // accessKey: "test",
      // activationCode: "test",
      // gender: 'male',
      // company: "cf",
      // employmentStatus: "Employed",
      employmentStatuses: ['Employed', 'Dependent', 'Not Applicable'],
			/* form fields */
			errorMessages: '',
			confirmDialog: false,
      successDialog: false,
      showCode: false,
      showKey: false,
      banner: [],
      breadcrumbs: [
				{
					name: "Medgate",
					link: "/",
					active: false
				},
				{
					name: "Shop",
					link: "/shop",
					active: false
        },
        {
					name: "Key Assignment",
					link: "/shop/assignment",
					active: true
				},
      ],
      errorDialog: {
        show: false,
        title: null,
        message: null
      },
      loading: false
		}
  },
  watch: {
    birthdate(val) {
      this.birthdateFormatted = this.formatDate(val)
    },
  },
  computed: {
    birthdateFormat () {
      return this.formatDate(this.birthdate)
    },
    assignmentForm() {
      return {
        firstName: this.firstName,
        middleName: this.middleName,
        lastName: this.lastName,
        birthdate: this.birthdate,
        emailAddress: this.emailAddress,
        contactNumber: this.contactNumber,
        accessKey: this.accessKey,
        activationCode: this.activationCode,
        gender: this.gender,
        employmentStatus: this.employmentStatus,
        // providerNumber: this.providerNumber,
        company: this.company
      }
    },
    maxDate() {
      let date = new Date()
      date.setDate(date.getDate() - 1);

      return  date.toISOString().substr(0, 10);
    }
  },
  async mounted() {
    await this.getAssignmentBanner();
    this.setHeaderColor();
  },
  methods: {
    formatDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${month}/${day}/${year}`
    },
    setHeaderColor() {
      if (this.banner.backgroundColor)
        this.$store.commit('page/setHeaderColor', this.banner.backgroundColor)
      else
        this.$store.commit('page/defaultHeaderColor')
    },
    async getAssignmentBanner() {
      try {
        const { data } = await ShopAssignmentBannersApi.get();
        
        if (data) {
          data.data.sort(function(a, b) {
            return a.precedence - b.precedence;
          });
          
          let apiData = data.data[0];

          let buttons = apiData.buttons.map(button => {
            return {
              name: button.label,
              icon: button.image,
              link: button.redirect,
              color: JSON.parse(button.styling).color
            }
          });

          let banner = {
            buttons: buttons,
            image: apiData.background_image.main,
            caption: apiData.caption,
            title: apiData.title,
            titleColor: apiData.styles.titleColor,
            captionColor: apiData.styles.captionColor,
            backgroundColor: apiData.styles.backgroundColor
          }

          this.banner = banner;
        }

        console.log('[shop-assignment-banner]', data, this.banner);
      }
      catch(error) {
        console.log(error);
      }
    },
    confirmAssignmentInfo() {
      if (this.$refs.assignmentForm.validate()) this.confirmDialog = true;
		},
		saveAssignmentInfo() {
      this.loading = true;

      let form = {
        'first_name': this.firstName,
        'middle_name': this.middleName,
        'last_name': this.lastName,
        'birthdate': this.birthdate,
        'email': this.emailAddress,
        'phone_number': this.contactNumber,
        'access_key': this.accessKey,
        'activation_code': this.activationCode,
        'gender': this.gender,
        'employment_status': this.employmentStatus,
        // 'provider_number': this.providerNumber,
      };

      if (this.company) {
        form.company = this.company;
      }
      
      KeyAssignmentApi.create(form)
        .then(response => {
          console.log({ response });

          if (response) {
            this.confirmDialog = false;
            this.successDialog = true;
          }
        })
        .catch(error => {
          console.log({ error });
          this.errorDialog = {
            show: true,
            title: "Failed key assignment",
            message: error.response.data.message
          };
        })
        .finally(() => {
          this.loading = false
        })


      // try {
      //   let save = await Api.create(this.contactForm);

      //   if (save) {
          // this.successDialog = true;
      //     localStorage.removeItem('cartItems');
      //   }
      //   else {
      //     console.log("Sorry, there was a problem saving your transaction.");
      //   }
      // }
      // catch(error) {
      //   console.log(error);
      // }
		}
  }
};
</script>

<style scoped lang="scss">
@import "@/assets/styles/variables.scss";

// #header {
// 	height: 750px;
// 	background-size: 26% 0% / 118%;
// }

#assignment {
  background: $gray2;

  .card {
    padding: 5%;
  }
}
</style>